import type { AssetWithStats } from '@/common/asset';
import { GoogleMapsProvider } from '@/components/map/GoogleMapsProvider';
import { AssetGoogleMap } from './AssetGoogleMap';

export type AssetsMapContainerProps = {
	assets: AssetWithStats[];
	selectedAsset: AssetWithStats | null;
	onSelectAsset: (asset: AssetWithStats) => void;
	showSidePanel?: boolean;
	toggleSidePanel?: () => void;
	leftPanelWidth?: number;
};

export function AssetsMapContainer({
	assets,
	selectedAsset,
	onSelectAsset,
	toggleSidePanel,
	showSidePanel,
	leftPanelWidth,
}: AssetsMapContainerProps) {
	// if (assets.length === 0) {
	// 	return <div className="p-4">No Assets with location data available.</div>;
	// }

	return (
		<GoogleMapsProvider>
			<AssetGoogleMap
				assets={assets}
				selectedAsset={selectedAsset}
				onSelectAsset={onSelectAsset}
				showSidePanel={showSidePanel}
				toggleSidePanel={toggleSidePanel}
				leftPanelWidth={leftPanelWidth}
			/>
		</GoogleMapsProvider>
	);
}
